import PrimaryAppbar from './PrimaryAppbar'

export default PrimaryAppbar
